<template>
  <div>
  <div class="mt-n2">
    <menu-tabs
      @setMenuOption="setMenuOption" 
      @selectedProperty="selectedProperty"
    ></menu-tabs>

    <div class="mr-6" :class="{ 'mt-5' : !isPropertyLevel }">

      <hb-data-table-header
        v-if="!isPropertyLevel"
        left-columns="5"
        right-columns="7"
      > 
        <template v-slot:description>
          <HbTextField
            v-if="!isPropertyLevel && (isDocuments || filter_active || searchbox?.length >0)"
            search
            v-model="searchbox"
            v-validate="'required|max:45'"
            data-vv-scope="default"
            data-vv-name="text-field-search"
            data-vv-as="Text Field Search"
            :error="errors.has('default.text-field-search')"
            placeholder="Search"
            @keyup.enter.native="onSearchEnter"
            @click:clear="clearText"
          />
        </template>
        <template v-slot:actions>
          <div v-if="!isPropertyLevel && (isDocuments || filter_active || searchbox?.length >0)">
              <HbBtn
                class="sameline"
                :active="filter_active"
                :active-state-off="!filter_active"
                icon
                tooltip="Filter"
                mdi-code="mdi-filter-variant"
                @click="openFilterModal"
              />
              <hb-btn
                v-if="hasPermission('create_template')"
                class="sameline"
                color="secondary"
                small
                @click="uploadDocument"
                >Create New Template</hb-btn
              >
            </div>
        </template>
      </hb-data-table-header>
      
      <v-row class="justify-center ma-0 pa-0" v-if="!isDocumentsLoaded">
        <v-progress-circular
            indeterminate
            color="primary"
        ></v-progress-circular>
      </v-row>

      <document-library v-if="isDocumentsLoaded && (isDocuments || filter_active || searchbox?.length >0)" :isPropertyLevel="isPropertyLevel" :property="property" @editItem="uploadDocument" @onDocumentsUpdated="fetchDocumentsList" :level="level" :permissions="permissions"></document-library>
      <hb-empty-state
        v-else-if="isDocumentsLoaded && showEmptyStateContainer"
        :message="emptyStateMessage"
        btn-txt="Create New Template"
        :show-btn="isShowBtn"
        :disabled="false"
        @clicked="uploadDocument"
      ></hb-empty-state>
      <upload-document-modal v-if="is_upload_document" v-model="is_upload_document" :selected="selected" @onDocumentsUpdated="fetchDocumentsList"></upload-document-modal>
    </div>
  </div>
  <hb-modal size="large" title="Filter By" v-model="is_filter_modal_open"  @close="cancelFilters()">
      <template v-slot:content>
        <div class="filterModalContainer">
          <div class="row">
            <div class="left-column">Template Type</div>
            <div class="right-column">
              <HbCheckbox
                v-for="item in getUnSignedDocumentTypes"
                :key="item.id"
                :label="item.name"
                v-model="filters[item.value]"
              />
            </div>
          </div>

          <div class="row">
            <div class="left-column">Properties</div>
            <div class="right-column">
              <div class="vselect">
                <hb-combobox
                  :items="getPropertiesList"
                  item-text="name"
                  item-value="id"
                  label="Select"
                  v-model="selectedPropertyIds"
                ></hb-combobox>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="left-column">Status</div>
            <div class="right-column last-column">
              <HbCheckbox label="Signed" v-model="signed" />
              <HbCheckbox label="Unsigned" v-model="unsigned" />
            </div>
          </div>
        </div>
      </template>
      <template v-slot:left-actions> </template>
      <template v-slot:right-actions>
        <hb-btn @click="resetFilters()" color="secondary">Reset</hb-btn>
        <hb-btn @click="applyFilters()">Apply</hb-btn>
      </template>
    </hb-modal>
    </div>
</template> 

<script type="text/babel">
import DocumentLibrary from './DocumentLibrary'; 
import UploadDocumentModal from './UploadDocumentModal';
import MenuTabs from '../Common/MenuTabs';
import api from '../../../assets/api.js';
import { EventBus } from '../../../EventBus.js';
import {mapGetters, mapActions, mapMutations} from 'vuex';
import { notificationMixin } from '@/mixins/notificationMixin.js';
import GUIDES from "@/constants/guides.js";
import TemplateForm from './TemplateForm.vue';

export default {
  name: "DocumentManagerIndex",
  data() {
    return {
      level: 'corporate',
      property: {},
      permissions: {
        edit: false,
        delete: false
      },
      nav_drawer: false,
      is_upload_document: false,
      selected: {},
      documentsLoading: false,
      is_filter_modal_open: false,
      filter_active: false,
      searchbox: '',
      selectedPropertyIds: [],
      filters: {},
      signed: false,
      unsigned: false,
      previous_filters: {}, 
      previous_properties: [],
      previous_search: '',
      previous_signed: false,
      previous_unsigned: false
    }
  },
  components: {
    DocumentLibrary,
    UploadDocumentModal,
    MenuTabs,
    TemplateForm
  },
  mixins: [notificationMixin],
  async created() {
    this.GUIDES = GUIDES;
    this.documentsLoading = true;
    await this.fetchDocumentsList();
    await this.fetchUnSignedDocumentTypes();
    this.getUnSignedDocumentTypes.forEach(item => {
      this.$set(this.filters, item.value, false);
   });
    this.documentsLoading = false;
    this.permissions = {
      edit: this.hasPermission("edit_template"),
      delete: this.hasPermission("delete_template")
    }
  },
  computed: {
    ...mapGetters({
      getSettingsData: 'documentsStore/getSettingsData',
      getPropertiesList: 'propertiesStore/filtered',
      getUnSignedDocumentTypes: 'documentsStore/getUnSignedDocumentTypes'
    }),
    isPropertyLevel() {
      return this.level == 'property' ? true : false;
    },
    showEmptyStateContainer() {
      return this.isPropertyLevel ? true : (this.getSettingsData[this.level] && this.getSettingsData[this.level].length) ? false : true;
    },
    isShowBtn() {
      return this.isPropertyLevel ? false : true;
    },
    emptyStateMessage() {
      return (this.isPropertyLevel && this.isPropertySelected) ? 'Assign Document Templates to this property from the Corporate Settings tab.' : this.isPropertyLevel ? "Please select a Property to continue." : "There are no documents in your library.";
    },
    isPropertySelected() {
      return (this.property && this.property.id) ? true : false;
    },
    isDocuments() {
      return (this.getSettingsData && this.getSettingsData[this.level].length) ? true : false;
    },
    isDocumentsLoaded() {
      return this.documentsLoading ? false : true;
    }
  },
  methods: {
    ...mapActions({
      fetchDocuments: 'documentsStore/fetchDocuments',
      fetchSettingsData: 'documentsStore/fetchSettingsData',
      fetchSettingsDataWithBody: 'documentsStore/fetchSettingsDataWithBody',
      fetchUnSignedDocumentTypes: 'documentsStore/fetchUnSignedDocumentTypes',
      fetchDocumentsByProperty: 'propertiesStore/fetchDocumentsByProperty',
      deleteDocument: 'documentsStore/deleteDocument',
      defaultProperty: "propertiesStore/defaultProperty"
      
    }),
    ...mapMutations({
      setSettingsData: 'documentsStore/setSettingsData',
    }),


    // This method will be called only to fetch data for the first time.
    async fetchDocumentsList(level = this.level) {
      this.filter_active = false; 
      this.is_upload_document = false;
      this.documentsLoading = true;
      let limit = 20;
      let offset = 1
      if(this.isPropertyLevel && !this.property.id) return 
      let path = (this.isPropertyLevel) ? `&property_ids[]=${this.property.id}` : '';
      let data = {
        component: this,
        params: api.DOCUMENT + `?limit=${limit}&offset=${offset}` + path,
        level: level
      }
      try {
        const emptyData = {
          this: this,
          level: level,
          data: []
        }
        await this.setSettingsData(emptyData)
        await this.fetchSettingsData(data)
      } catch(err) {
        this.showMessageNotification({ description: err });
      } finally {
        this.documentsLoading = false;
      }
    },
    async setMenuOption(option) {
      this.documentsLoading = true;
      this.level = option;
      if(this.isPropertyLevel) {
        const emptyData = {
          this: this,
          level: this.level,
          data: []
        }
        await this.setSettingsData(emptyData)
        if(this.isPropertySelected) {
          await this.fetchDocumentsList(this.level);
        }
      } else {
        await this.fetchDocumentsList(this.level);
      }
      this.documentsLoading = false;
    },
    async selectedProperty(property) {
      this.resetFilters()
      if(this.property != property){
        this.property = property;
        if(this.isPropertySelected) await this.fetchDocumentsList(this.level);
      }
    },
    uploadDocument(item = {}) {
      EventBus.$emit('HB-Navigation:DocumentTemplate', {
        ...item
      });
      // this.selected = item;
      // this.is_upload_document = true;
    },
    setDocumentsLoading(val) {
      this.documentsLoading = val;
    },
    async onSearchEnter() {
      this.is_upload_document = false;
      this.documentsLoading = true;
      let limit = 1000;
      let offset = 1
      let path = (this.isPropertyLevel) ? `&property_ids[]=${this.property.id}` : '';
      let data = {
        component: this,
        params: api.DOCUMENT + `/filter?limit=${limit}&offset=${offset}` + path,
        body: {
          search: this.searchbox, 
          property_ids: this.selectedPropertyIds.map(_=>_.id),
          filters: Object.keys(this.filters).filter(key => this.filters[key]),
          signed: this.signed, 
          unsigned: this.unsigned
        }
      }
      try {
        const emptyData = {
          this: this,
          level: this.level,
          data: []
        }
        await this.setSettingsData(emptyData)
        await this.fetchSettingsData(data)
      } catch(err) {
        this.showMessageNotification({ description: err });
      } finally {
        this.documentsLoading = false;
      }
    },
    async openFilterModal() {
      this.is_filter_modal_open = true;
    },
    async applyFilters() {
      this.previous_search = this.searchbox
      this.previous_properties = this.selectedPropertyIds.map(_=>_.id)
      this.previous_filters = { ...this.filters };
      this.previous_signed = this.signed 
      this.previous_unsigned = this.unsigned
      if(this.selectedPropertyIds.length > 0 || Object.values(this.filters).includes(true) || this.signed || this.unsigned) {
        this.filter_active = true
      } else this.filter_active = false
      this.onSearchEnter();
      this.is_filter_modal_open = false;
    },
    async resetFilters() {
      Object.keys(this.filters).forEach(key => {
        this.filters[key] = false;
      });
      this.selectedPropertyIds = []
      this.searchbox = ''
      this.signed = false 
      this.unsigned = false
    },
    async cancelFilters() {
      this.searchbox = this.previous_search
      this.selectedPropertyIds = this.previous_properties
      this.filters = {...this.previous_filters}
      this.signed = this.previous_signed
      this.unsigned = this.previous_unsigned
    },
    async clearText() {
      this.searchbox = ''
      this.onSearchEnter();
    }
  },
  watch: {
   searchbox(newVal, oldVal) {
      if(newVal === "" && oldVal.length > 0){
        this.searchbox = " "
      }
  }
}

}
</script>

<style lang="scss" scoped>
.heading {
  height: 21px;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.5;
}
.description {
  font-size: 14px;
  color: #637381;
}
.sameline {
  display: inline-block;
  vertical-align: middle; /* Optional: Aligns elements vertically if needed */
  margin-right: 1vw; /* Optional: Adds spacing between elements */
}
.filterModalContainer {
  overflow: hidden;
}
.row {
  display: grid;
  grid-template-columns: 1fr 3fr; /* 25% / 75% split */
  border-bottom: solid 1px #8e8e8f26;
  border-left: 50px;
  width: 100%;
  box-sizing: border-box;
}

.left-column {
  background-color: #8e8e8f26;
  padding-left: 1.5vw;
  padding-top: 2vh;
  font-weight: 500;
  font-size: small;
  margin-left: 4%;
}

.right-column {
  width: 100%;
  padding-top: 1vh;
}

.full-width {
  display: block;
  height: auto;
  min-height: 100px;
  position: relative;
  z-index: 1000;
}
.vselect {
  margin-bottom: 2%;
  margin-left: 1%;
}

.gray-select ::v-deep input::placeholder {
  color: #637381 !important;
}
.last-column {
  margin-bottom: 5%;
}
</style>